module.exports = __webpack_public_path__ + "static/media/close-icon.fa0d04b4.svg";